import { TYPEFORM_URL_PREFIX } from './constants'

export default function typeformIdToUrl(formId: string): string {
  return `${TYPEFORM_URL_PREFIX}${formId}`
}
